export const SHOP_SELECTION = `
    id
    haveSlotDiscount
    rating
    isActive
    isClosed
    slug
    name
    description
    minPrice
    maxPrice
    displayedAddress
    oldStreetAddress
    phone
    openHour
    closeHour
    allowBooking
    location
    avatar {
        url
        alt
        sizes {
          card {
            url
          }
          thumbnail {
            url
            
          }
        }
      }
    shopFacilities {
      id
      name
    }
    shopChain {
      headOffice {
        id
        name
        displayedAddress
      }
      shops {
        id
        name
        displayedAddress
        avatar {
          url
          alt
        }
      }
    }
    bookingDayOfWeek {
      dayOfWeek
      startTime
      endTime
      timeGap
      bookingNumberLimit
    }
    gallery {
      url
      alt 
    }
    mainShopCategory {
      id
      name
      code
    }
    province {
      id
      name
      shortCode
      provinceCode
    }
    

    createdAt
    updatedAt
    createdBy {
      id
      name
      phone
      email
    }
    updatedBy {
      id
      name
      phone
      email
    }
    meta {
      title
      description
      keywords
    }
`;
// ward {
//   id
//   name
//   wardCode
//   provinceCode
// }
export const SHOP_CARD_SELECTION = `
    id
    name
    displayedAddress
    allowBooking
    openHour
    closeHour
    rating
    location
    haveSlotDiscount
    minPrice
    avatar {
      url
      alt
    }
    gallery {
      url
      alt
    }
    mainShopCategory {
      id
      name
      code
    }
    slug
`;

export const SHOP_SHORT_SELECTION = `
    id
    name
    displayedAddress
    allowBooking
    haveSlotDiscount
    openHour
    closeHour
    rating
    location
    avatar {
      url
      alt
    }
    subShopCategories {
      id
      name
    }
    slug
`;
